import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { SwitchProps } from "./PropsType";

export default function Switch(props: SwitchProps) {
    const [checked, setChecked] = useState(!!props.defaultChecked);
  const handleInputChange = (event: any) => {
    const checked = event.target.checked;
    setChecked(checked);
    if (props.onChange) {
      props.onChange(checked);
    }
  };

  const { children, className, disabled, inputType = 2 } = props;
  const styleClass = classNames(
    "Switch",
    inputType && `Switch-${inputType}`,
    className
  );

  useEffect(() => {
    setChecked(!!props.checked);
  }, [props.checked]);

  return (
    <label className={styleClass}>
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={handleInputChange}
      />
      <div className="Switch-inner">{children}</div>
      <div className="Switch-media">
        <span className="Switch-label" />
      </div>
    </label>
  );
}
